// extracted by mini-css-extract-plugin
export default {"root":"subjectIcon_root__TgNLV","icon":"subjectIcon_icon__BdIDX","selected":"subjectIcon_selected__Yy1QU"};